import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const RedirectToPrivacySideapps = () => {
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mobile = params.get("mobile");
    const ssoPage = params.get("ssoPage");

    if (mobile === "true") {
      history.replace("/privacy/sideapps/mobile");
    } else if (ssoPage === "true") {
      history.replace("/privacy/sideapps/ssopage");
    } else {
      history.replace("/privacy/sideapps");
    }
  }, [history]);

  return null;
};

export default RedirectToPrivacySideapps;
